// هوک‌های مشترک صفحات DOC: قالب‌های منتشرشده فرم و رضایت و فیلدهای اضافه رضایت‌نامه.
import { unwrap, type DocConsentTemplateView } from '@phoenix/api-client';
import { useTenantSession } from '@phoenix/auth';
import { useQuery } from '@tanstack/react-query';
import { docKeys } from './common';

export function usePublishedForms(enabled = true) {
  const { tenantApi, session } = useTenantSession();
  return useQuery({
    queryKey: docKeys.publishedForms(session?.tenantId),
    queryFn: () => unwrap(tenantApi.GET('/api/v1/documents/form-templates/published', { params: { query: {} } })),
    enabled,
  });
}

export function usePublishedConsents(enabled = true) {
  const { tenantApi, session } = useTenantSession();
  return useQuery({
    queryKey: docKeys.publishedConsents(session?.tenantId),
    queryFn: () => unwrap(tenantApi.GET('/api/v1/documents/consent-templates/published')),
    enabled,
  });
}

interface ExtraField {
  key: string;
  label: string;
  required?: boolean;
}

export function extraFieldsOf(template: DocConsentTemplateView | undefined): ExtraField[] {
  const content = template?.content as { extraFields?: ExtraField[] } | null | undefined;
  return content?.extraFields ?? [];
}

